import { type CardStylingDataStructure } from 'javascripts/shared-types';
import CardStyling from '../CardStyling';
import { type CardLayoutModelConstructorType } from '../types';
import { type CardStylingTypesEnum_value } from 'components/framework/models/generated/types';
import { type Feature } from '../../../framework/models';
import { mixColorForTheme } from '../../../../javascripts/theme';

export class BackgroundFeatureType extends CardStyling {
  static type: CardStylingTypesEnum_value = 'BackgroundFeatureType';
  static title: string = 'Feature type (background)';

  static availableForModel(
    modelClass: CardLayoutModelConstructorType
  ): boolean {
    return super.availableForModel(modelClass);
  }

  static subqueriesForModel(_modelClass: CardLayoutModelConstructorType) {
    return { workflowKind: ['color'] };
  }

  exampleCardStyling() {
    return {
      highlightColor: '#C9250E',
      useBackgroundColor: true,
    };
  }

  cardStyling(record: Feature): CardStylingDataStructure {
    const workflowKind = record.workflowKind;
    if (!workflowKind) return {};

    const { colorObject } = workflowKind;
    if (!colorObject) return {};

    return {
      highlightColor: mixColorForTheme(colorObject).hex(),
      useBackgroundColor: true,
    };
  }
}
